<template>
  <div class="create-edit-view-layout">
    <component :is="component" v-bind.sync="data" />
  </div>
</template>

<script>
export default {
  name: "CreateEditViewLayout",
  computed: {
    component() {
      return this.$store.state.CreateEditViewLayout.createEditComponent;
    },
    data() {
      return this.$store.state.CreateEditViewLayout.createEditComponentData;
    }
  }
};
</script>

<style lang="scss" scoped>
.create-edit-view-layout {
  box-shadow: -8px 0 24px 0 rgba(0, 0, 0, 0.2);
  @apply absolute top-0 right-0 bottom-0 w-full px-4 py-6 bg-lightgray-lightest z-50 pointer-events-auto overflow-y-auto;

  @screen md {
    @apply min-w-128 w-1/2 p-16;
  }

  @screen lg {
    @apply w-1/3;
  }
}
</style>
